import React from 'react';
import { Table, Empty } from 'antd';
import MovimientoInventarioUnidadesFisicasTable from './MovimientoInventarioUnidadesFisicasTable';
export default class ProductoInventarioValorizadoTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }
    render() {
        return (
            <Table
                className={'logistica-table-inventario-producto'}
                scroll={{ x: true }}
                size="small"
                style={{ overflowX: 'auto' }}
                pagination={false}
                dataSource={this.props.dataSource}
                rowKey={record => record.id}
               onExpand={async (expanded, record) => {
                   
                    await this.props.onSearchInventarioUnidadesFisicasMovimiento(record);
                }}
                expandedRowRender={(record) => {
                    return (
                        <div style={{ margin: '10px 0px' }}>
                            <MovimientoInventarioUnidadesFisicasTable dataSource={record.movimientos} />
                        </div>
                    )
                }}
                locale={{
                    emptyText: <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description='No se encontraron datos.'
                    />
                }}
                columns={[
                    {
                        title: 'Producto',
                        dataIndex: 'nombre',
                        key: 'nombre'
                    },
                    {
                        title: 'Unidad Medida',
                        dataIndex: 'unidadMedida',
                        className: 'child-group',
                        key: 'unidadMedida'
                    },
                    {
                        title: 'Cantidades',
                        className: 'parent-group',
                        children: [
                            {
                                title: 'Ingresos',
                                dataIndex: 'ingresoCantidad',
                                key: 'ingresoCantidad',
                                align: 'right',
                                className: 'child-group',
                                render: (data) => (
                                    <span>{data.toFixed(3)}</span>
                                )
                            },
                            {
                                title: 'Salidas',
                                dataIndex: 'salidaCantidad',
                                key: 'salidaCantidad',
                                align: 'right',
                                className: 'child-group',
                                render: (data) => (
                                    <span>{data.toFixed(3)}</span>
                                )
                            }
                        ]
                    }
                ]}
            />
        );
    }
}